import React from 'react'

export default function SmallDecorator({ children }) {
  return <small style={{ fontSize: '0.75rem' }}>{children}</small>
}
